import React, {FC} from 'react';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import LogoHorizontalColor from './logos/LogoHorizontalColor';

const stackSx = {
  minHeight: 25,
  position: 'relative',
  bottom: 0,
  right: 2
};

type GeomaticoLinkProps = {
  width?: number
}

const GeomaticoLink: FC<GeomaticoLinkProps> = ({width=80}) => <Stack sx={stackSx}>
  <Link href="https://geomatico.es" target="_blank">
    <LogoHorizontalColor width={width}/>
  </Link>
</Stack>;

export default GeomaticoLink;
